import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/vacancies/types';

const initialState = Immutable.fromJS({
  isSummaryLoading: false,
  isFormLoading: false,
  isVacancyPosting: false,
  isVacancyPuttingOnHold: false,
  isVacancyRePosting: false,
  isVacancyArchiving: false,
  isVacancyKeepingPosted: false,
  isVacancyRemainingOnHold: false,
  isDraftVacancyDeleting: false,
  vacancySummary: {},
  error: null
});

export default reducerCreator(initialState, {
  [types.VACANCY_SET_SUMMARY_LOADING]: (state, { isLoading }) =>
    state.set('isSummaryLoading', isLoading),

  [types.VACANCY_SET_FORM_LOADING]: (state, { isLoading }) =>
    state.set('isFormLoading', isLoading),

  [types.VACANCY_SET_VACANCY_POSTING]: (state, { isLoading }) =>
    state.set('isVacancyPosting', isLoading),

  [types.VACANCY_SET_VACANCY_PUTTING_ON_HOLD]: (state, { isLoading }) =>
    state.set('isVacancyPuttingOnHold', isLoading),

  [types.VACANCY_SET_VACANCY_RE_POSTING]: (state, { isLoading }) =>
    state.set('isVacancyRePosting', isLoading),

  [types.VACANCY_SET_VACANCY_ARCHIVING]: (state, { isLoading }) =>
    state.set('isVacancyArchiving', isLoading),

  [types.VACANCIES_SET_VACANCY_KEEPING_POSTED]: (state, { isLoading }) =>
    state.set('isVacancyKeepingPosted', isLoading),

  [types.VACANCIES_SET_VACANCY_REMAINING_ON_HOLD]: (state, { isLoading }) =>
    state.set('isVacancyRemainingOnHold', isLoading),

  [types.VACANCY_SET_SUMMARY]: (state, { vacancySummary }) =>
    state.set('vacancySummary', Immutable.fromJS(vacancySummary)),

  [types.VACANCIES_SET_DRAFT_VACANCY_DELETING]: (state, { isLoading }) =>
    state.set('isDraftVacancyDeleting', isLoading),

  [types.VACANCY_SET_SUMMARY_ERROR]: (state, { error }) =>
    state.set('error', error),

  [types.VACANCY_RESET_SUMMARY]: () => initialState
});



// WEBPACK FOOTER //
// ./src/reducers/vacancies/vacancy-details.js